"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bootstrap = void 0;
var _reduxActions = require("redux-actions");
var PREFIX = 'BASKET_COUNTER';
var bootstrap = exports.bootstrap = (0, _reduxActions.createAction)("".concat(PREFIX, "/bootstrap"));